"use strict";
import FloatingStyle from "../labels/FloatingLabel.less";

export const combined30 = {
    "template": "FieldSetTemplate",
    "className": FloatingStyle.combined30
};
export const combined50 = {
    "template": "FieldSetTemplate",
    "className": FloatingStyle.combined50
};
export const combined70 = {
    "template": "FieldSetTemplate",
    "className": FloatingStyle.combined70
};
export const combined3333 = {
    "template": "FieldSetTemplate",
    "className": FloatingStyle.combined3333
};
export const combined100 = {
    "template": "FieldSetTemplate",
    "className": FloatingStyle.combined100
};
export const dateOfBirth = {
    "template": "FieldSetTemplate",
    "className": FloatingStyle.dateOfBirth
};
export const dateOfBirthContainer = {
    "template": "FieldSetTemplate",
    "className": FloatingStyle.dateOfBirthContainer
};

export default ({
    combined30,
    combined50,
    combined70,
    combined3333,
    combined100,
    dateOfBirthContainer,
    dateOfBirth
});



/** WEBPACK FOOTER **
 ** ./src/templates/CombinedBundle.js
 **/